import React from 'react'
import styled from "styled-components"
const Section = (props) => {
    return (
        <Wrap bgImage={props.backgroundImg}>
            <ItemText>
                <h1>{props.title}</h1>
                <p>{props.description}</p>
            </ItemText>
            <Buttons>
                <ButtonGroup>
                    <LeftButton>
                        Custom Order
                    </LeftButton>
                    <RightButton>
                        Existing Inventory
                    </RightButton>
                </ButtonGroup>
                <DownArrow src="images/down-arrow.svg">

                </DownArrow>
            </Buttons>
        </Wrap>
    )
}

export default Section
const Wrap = styled.div`
    width: 100vw;
    height: 100vh;
    align-items: center;
    background-size: cover;
    background-position: center;
    background-image: ${props => `url("${props.bgImage}")`};
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`

const ItemText = styled.div`
padding-top: 15vh;
`

const ButtonGroup = styled.div`
display: flex;
@media (max-width: 768px){
    flex-direction: column;
}
`
const LeftButton = styled.div`
    background-color: rgba(23,26,32,0.8);
    height: 40px;
    width: 256px;
    color:white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    opacity: 0.85;
    text-transform: uppercase;
    font-size: 12px;
    cursor: pointer;
    margin: 8px;
`

const RightButton = styled(LeftButton)`
    background: white;
    opacity: 0.65;
    color: black;
`


const DownArrow = styled.img`
margin-top: 20px;
margin-left: 18vw;
height: 50px;
animation: animateDown infinite 1.5s
`

const Buttons = styled.div`
align-items: center;
`